import { useParams } from 'react-router-dom';
import styles from './action-pages.module.css';

export default function ProductInfo(){
    const string = useParams().string;

    const productList = [
        {
            itemCode: "001",
            itemEncryption: "G7fKq9xZ2Lr4P8A",
            itemImage: "hand-carved-wooden-decorative-item.png",
            name: "Hand carved wooden decorative item",
            description: "This item is classically carved by skilled artisan using hand tools. These items often include figurines, wall hangings, furniture accents, and ornaments. Each piece is unique, reflecting traditional techniques, cultural motifs, and the carver’s creativity.",
            artisan: "Carved by Artisan Sh. Om Prakash Suthar (contact- 9413844572)",
            location: "https://maps.app.goo.gl/4xEERknNaPZ12rNo9?g_st=iwb"
        },
        {
            itemCode: "002",
            itemEncryption: "X1tWv6MjY0eNc3B",
            itemImage: "handwoven-salawas-durry.png",
            name: "Handwoven Salawas Durry",
            description: "It is a traditional flat-weave rug made in Salawas, a village near Jodhpur in Rajasthan, India. Crafted by local artisans, these durries are made using cotton or wool and are known for their geometric patterns, vibrant colors, and durability.",
            artisan: "Wooven by artisans at ABI crafts (contact-9928981105)",
            location: "https://maps.app.goo.gl/aLiEDeKqLWAT6hti9?g_st=iwb"
        },
        {
            itemCode: "003",
            itemEncryption: "Zp4Lm8RdQa7Yo5V",
            itemImage: "hand-made-mojari.png",
            name: "Hand made Mojari",
            description: "It is a traditional Indian footwear crafted from leather, often decorated with intricate embroidery or embellishments. Originating from Rajasthan and Punjab, mojadis are known for their pointed toes and slip-on style.",
            artisan: "Crafted by Artisan Sh. Mahesh ji at Kappu Mojari (Contact- 8561079991)",
            location: "https://maps.app.goo.gl/oo4y4GNSMjYaw9tX7?g_st=iw"
        },
        {
            itemCode: "004",
            itemEncryption: "nC9XbE6gK3PtqUd",
            itemImage: "hand-made-leather-bag.png",
            name: "Hand made leather bag",
            description: "It is made in Jodhpur using traditional Rajasthani techniques and locally sourced leather. Jodhpur artisans are known for their skilled craftsmanship, intricate detailing, and use of natural dyes.",
            artisan: "Made by Artisan Sh. Naveen (Contact- 9571481399)",
            location: "https://maps.app.goo.gl/4PTwBiM8YdAAkgkw6?g_st=iw"
        },
        {
            itemCode: "005",
            itemEncryption: "Vj2YwXr1Ao9LmQe",
            itemImage: "royal-echoes-in-wood.png",
            name: "Royal Echoes in Wood",
            description: "This handcrafted wall decor blends tribal aesthetics with modern design. Made from premium wood and detailed with bold accents, it adds a royal yet contemporary touch to any space. Rooted in tradition and refined for today’s interiors, each piece tells a story of Indian artistry reimagined for the modern home.",
            artisan: "Crafted by Divya Gehlot at Saidiv_artistry (Contact: 8107249964)",
            location: "https://maps.app.goo.gl/NQXc3iS6aTjBSN3S9?g_st=com.google.maps.preview.copy"
        },
        {
            itemCode: "006",
            itemEncryption: "R8zTnLdPk5FYbW0",
            name: "Handcrafted pottery items",
            description: "It is pottery item made by hand using traditional techniques like wheel-throwing, coiling, or slab-building. Each piece is unique, shaped and decorated by artisans without mass-production machinery.",
            artisan: "Made by artisan Sh. Mangi lal(Contact- 9340993424)",
            location: "https://maps.app.goo.gl/ERJ1K7QZMAKd6FFW9?g_st=iwb"
        }
    ]

    return (<>
        <div className={styles['bharat-bio-science-container']}>
            <h1>Product info</h1>
            {productList.filter(item => item.itemEncryption === string).map((product, index) => (
                <div key={index} className={styles['bharat-bio-science']}>
                    <p>{product.name}</p>
                    {product.itemImage && <div className={styles['product-image']}><img src={`../../assets/images/product-info/${product.itemImage}`} alt={product.name} /></div>}
                    <ul>
                        <li><span>Description:</span> {product.description}</li>
                        <li><span>Artisan:</span> {product.artisan}</li>
                        <li><span>Location:</span> <a href={product.location} target="_blank" rel="noopener noreferrer">View on Map</a></li>
                    </ul>
                </div>
            ))}
        </div>
    </>)
}
